import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputComponent } from './input.component';
import { InputWrapperComponent } from './input-wrapper/input-wrapper.component';
import { FakeInputComponent } from './fake-input/fake-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { IconModule } from '../../icon/icon.module';
import { PipeModule } from '../../../modules/shared/pipes/pipe.module';

const COMPONENTS = [InputComponent, InputWrapperComponent, FakeInputComponent];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    A11yModule,
    PipeModule,
    IconModule,
  ],
  exports: [...COMPONENTS],
})
export class InputModule {}
